interface MenuItem {
	id: number;
	text: string;
	i18n: string;
	link: string;
	icon: string;
	href: null | string;
	target: null | string;
	items: MenuItem[] | null;
	contextItems: MenuItem[] | null;
}

// Función para encontrar un item en el menú recursivamente
const findMenuItemByPath = (
	menuItems: MenuItem[],
	path: string,
): MenuItem | undefined => {
	for (const item of menuItems) {
		if (item.link === path) {
			return item;
		}

		if (item.contextItems) {
			const foundInContext = findMenuItemByPath(item.contextItems, path);
			if (foundInContext) {
				return foundInContext;
			}
		}
		if (item.items) {
			const foundInItems = findMenuItemByPath(item.items, path);
			if (foundInItems) {
				return foundInItems;
			}
		}
	}
	return undefined;
};

// Función para obtener la ruta base de una URL
const getBaseRoute = (currentPath: string): string => {
	const pathParts = currentPath.split("/").filter(Boolean);

	if (pathParts.length <= 1) {
		return `/${pathParts[0] || ""}`;
	}

	return `/${pathParts[0]}`;
};

const getRouteTranslation = (
	currentPath: string,
	menuItems: MenuItem[],
): string | undefined => {
	const baseRoute = getBaseRoute(currentPath);
	const menuItem = findMenuItemByPath(menuItems, baseRoute);

	return menuItem?.i18n;
};

export function calculateTitle(location: { pathname: string }) {
	try {
		const menuItemsStr = localStorage.getItem("sideMenuItems");
		if (!menuItemsStr) return "back";

		const menuItems: MenuItem[] = JSON.parse(menuItemsStr);
		if (!Array.isArray(menuItems)) return "back";

		const translation = getRouteTranslation(location.pathname, menuItems);
		return translation || "back";
	} catch (error) {
		return "back";
	}
}
